import OrderConfirmedContainer from './OrderConfirmedContainer';
export default OrderConfirmedContainer;
